import React from 'react';
import Utils from '../shared/Utils';

const CountSelector = ({ changeCount, defaultValue, type, range, multiplier }) => (
  <div className='col-md-6 text-center'>
    <span className='space-right' children={Utils.t(`results.count.${type}`)} />
    <select
      className='custom-select medium-text space-top-small space-bottom-small'
      onChange={(e) => changeCount(e, `count_${type}`)}
      defaultValue={defaultValue}
    >
      {[...Array(range)].map((_x, index) => (
        <option
          key={`count-${type}-option-${index}`}
          className='custom-select-option'
          children={`${(index + 1) * multiplier}`}
        />
      ))}
    </select>
  </div>
);

const ResultsCountSwitcher = ({ fetching, changeCount, count_indiv, count_team }) => {
  const fetchingClass = fetching ? ' disabled-element' : '';

  return (
    <div className={`row${fetchingClass}`}>
      <CountSelector
        changeCount={changeCount}
        defaultValue={count_indiv}
        type='indiv'
        range={10}
        multiplier={10}
      />

      <CountSelector
        changeCount={changeCount}
        defaultValue={count_team}
        type='team'
        multiplier={1}
        range={20}
      />
    </div>
  );
}

export default ResultsCountSwitcher;
